import axios from 'axios';
import chatgptIcon from '../assests/images/chatgpt.png';
import ChatUserIcon from '../assests/images/user-icon.png';
import ClaudeAiIcon from '../assests/images/claude-ai-icon.png';
import DeepSeekIcon from '../assests/images/DeepSeekIcon.png';
import GeminiAiIcon from '../assests/images/gemini-ai-icon.png';
import NewChatIcon from '../assests/images/new-chat-icon.png';
import {
  EditOutlined,
  CheckCircleOutlined,
  ArrowsAltOutlined,
  CompressOutlined,
  ReadOutlined,
} from '@ant-design/icons';
import { axiosSecureInstance } from '../api/axios';

// Static bot icons map
export const botIconsMap = {
  openai: {
    name: 'ChatGPT',
    icon: chatgptIcon,
  },
  gemini: {
    name: 'Gemini',
    icon: GeminiAiIcon,
  },
  claude: {
    name: 'Claude',
    icon: ClaudeAiIcon,
  },
  deepseek: {
    name: 'DeepSeek',
    icon: DeepSeekIcon,
  },
  user: {
    name: 'User',
    icon: ChatUserIcon,
  },
  newChat: {
    name: 'New Chat',
    icon: NewChatIcon,
  },
};

// Static bot options
const staticBotOptions = [
  {
    value: 'openai',
    label: (
      <div id="bot-option-openai" className="d-flex align-items-center gap-2">
        <img
          src={chatgptIcon}
          alt='chatgpt'
          style={{
            width: '20px',
            height: '20px',
          }}
        />
        ChatGPT
      </div>
    ),
  },
  {
    value: 'gemini',
    label: (
      <div id="bot-option-gemini" className="d-flex align-items-center gap-2">
        <img
          src={GeminiAiIcon}
          alt='gemini'
          style={{
            width: '20px',
            height: '20px',
          }}
        />
        Gemini
      </div>
    ),
  },
  {
    value: 'claude',
    label: (
      <div id="bot-option-claude" className="d-flex align-items-center gap-2">
        <img
          src={ClaudeAiIcon}
          alt='claudeIcon'
          style={{
            width: '20px',
            height: '20px',
          }}
        />
        Claude
      </div>
    ),
  },
  {
    value: 'deepseek',
    label: (
      <div id="bot-option-deepseek" className="d-flex align-items-center gap-2">
        <img
          src={DeepSeekIcon}
          alt='DeepSeekIcon'
          style={{
            width: '20px',
            height: '20px',
          }}
        />
        DeepSeek
      </div>
    ),
  },
];

export const getDynamicBotOptions = async (userId) => {
  try {
    const response = await axiosSecureInstance.get(`/api/company-submission/${userId}`);
    const data = response.data;

    if (data && data.companyName && data.faviconPath) {

      const faviconUrl = `${process.env.REACT_APP_BASE_URL}uploads/favicons/${data.faviconPath}`;

      const companyOption = {
        value: data.companyName.toLowerCase(),
        label: (
          <div
            id={`bot-option-${data.companyName.toLowerCase()}`}
            className="d-flex align-items-center gap-2"
          >
            <img
              src={faviconUrl}
              alt={data.companyName}
              style={{
                width: '20px',
                height: '20px',
                objectFit: 'contain', 
              }}
              onError={(e) => {
                e.target.src = ChatUserIcon;
              }}
            />
            {data.companyName}
          </div>
        ),
      };
      return [companyOption];
    } else {
      console.warn('[getDynamicBotOptions] No company name or favicon found in response data:', data);
      return [];
    }
  } catch (error) {
    console.error('[getDynamicBotOptions] Error fetching company info:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    return [];
  }
};

export const buildModelOptions = (dynamicBotOptions = []) => {
	const staticModelOptions = {
	  openai: [
		{ value: "gpt-4o", label: "GPT-4o", description: "Best for complex tasks" },
		{ value: "gpt-4o-mini", label: "GPT-4o-mini", description: "Smaller, faster, supports large outputs" },
		{ value: "gpt-4.1", label: "GPT-4.1", description: "Good reasoning capabilities" },
		{ value: "gpt-4.1-nano", label: "GPT-4.1-nano", description: "Great for most tasks (No web search)" }
	  ],
	  claude: [
		{ value: "claude-3-5-sonnet-20240620", label: "Claude 3.5 Sonnet", description: "Improved speed and reasoning" }
	  ],
	  deepseek: [
		{ value: "deepseek-ai/DeepSeek-R1", label: "DeepSeek R1", description: "Best for complex problems" },
		{ value: "deepseek-ai/DeepSeek-V3", label: "DeepSeek V3", description: "Latest and fastest version" }
	  ],
	  gemini: [
		{ value: "gemini-2.0-flash-001", label: "Gemini 2.0 Flash", description: "Multimodal capabilities" }
	  ],
	};


	return staticModelOptions || {};
  };
  const staticModelOptions = {
	  openai: [
		{ value: "gpt-4o", label: "GPT-4o", description: "Best for complex tasks" },
		{ value: "gpt-4o-mini", label: "GPT-4o-mini", description: "Smaller, faster, supports large outputs" },
		{ value: "gpt-4.1", label: "GPT-4.1", description: "Good reasoning capabilities" },
		{ value: "gpt-4.1-nano", label: "GPT-4.1-nano", description: "Great for most tasks (No web search)" }
	  ],
	  claude: [
		{ value: "claude-3-5-sonnet-20240620", label: "Claude 3.5 Sonnet", description: "Improved speed and reasoning" }
	  ],
	  deepseek: [
		{ value: "deepseek-ai/DeepSeek-R1", label: "DeepSeek R1", description: "Best for complex problems" },
		{ value: "deepseek-ai/DeepSeek-V3", label: "DeepSeek V3", description: "Latest and fastest version" }
	  ],
	  gemini: [
		{ value: "gemini-2.0-flash-001", label: "Gemini 2.0 Flash", description: "Multimodal capabilities" }
	  ],
	};

export const botOptions = staticModelOptions;